// extracted by mini-css-extract-plugin
module.exports =  {"thirdPartyCompanyFeatureRequests":"K_gSRsJ9","header":"LI6sT9CZ","subtitle":"HY0q9Q4o","options":"Dq4PDBKE","searchInput":"fUkv9_QH","pagination":"jHDnIoMx"};